/**
 * The Bottleneck categories, copied from production's `report.tsx` and
 * `report-print.tsx` at `11ca09a` (both carry the same two maps).
 *
 * **Extracted, not transcribed.** Regenerate rather than hand-edit.
 *
 * Production prints the explanations in two places V2 had neither of: the
 * report's **Category Breakdown**, and its **Your Top Bottleneck Areas** panel.
 */
export const BOTTLENECK_LABELS: Record<string, string> = {
  avoidance: 'Avoidance',
  emotionalRegulation: 'Emotional Regulation',
  focus: 'Focus',
  goalClarity: 'Goal Clarity',
  identityPressure: 'Identity Pressure',
  isolation: 'Isolation',
  overextension: 'Overextension',
  recovery: 'Recovery',
};

/** What each category means for performance. */
export const BOTTLENECK_EXPLANATIONS: Record<string, string> = {
  avoidance:
    'A pattern of delaying or avoiding high-priority work despite knowing what needs to be done. Often driven by fear of failure, perfectionism, or emotional discomfort rather than lack of capability or motivation.',
  emotionalRegulation:
    'Difficulty managing emotional responses in ways that affect performance. Shows up as reactive decisions, sensitivity to criticism, mood-dependent productivity, or difficulty recovering from setbacks quickly.',
  focus:
    'Difficulty maintaining sustained attention on a single high-priority task. Often shows up as context-switching, distractibility, and an inability to reliably enter deep, uninterrupted work.',
  goalClarity:
    'Uncertainty about priorities, direction, or decision-making criteria. Creates hesitation, overthinking, and inconsistent effort allocation across competing demands.',
  identityPressure:
    'This pattern emerges when performance results become so entangled with self-worth that failure stops feeling like information and starts feeling like a verdict. It creates risk aversion, perfectionism, and difficulty recovering from setbacks, because falling short feels like a statement about who you are rather than a data point about what happened.',
  isolation:
    'Operating without adequate support, accountability, or outside perspective. Compounds blind spots and removes the friction, feedback, and leverage that accelerate growth.',
  overextension:
    'Taking on more than your system can sustainably handle creates a capacity problem that increased effort alone cannot solve. The system needs reduction, not acceleration.',
  recovery:
    'Insufficient physical and mental restoration relative to output demands. Results in depleted cognitive performance, reduced creativity, and emotional dysregulation that compound over time.',
};
